"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var IntervalKey;

(function (IntervalKey) {
  IntervalKey["day"] = "day";
  IntervalKey["month"] = "month";
  IntervalKey["quarter"] = "quarter";
  IntervalKey["year"] = "year";
})(IntervalKey = exports.IntervalKey || (exports.IntervalKey = {}));